import { Alert } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { Application } from 'src/components/context/AppContextModels';
import { FinsuiteIssueActionButton } from 'src/components/generic-components/action-buttons/AlertActionTicketButton';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';
import styles from './styles/EmbedApp.module.scss';
import { EmbeddingURLErrorMessages } from './utils/EmbeddingUtils';

interface EmbedAppErrorStateProps {
  application: Application;
  error: string;
}

export const EmbedAppErrorState: React.FC<EmbedAppErrorStateProps> = ({ application, error }) => {
  const envName = ENVIRONMENT_VARIABLES.env.Stage !== 'prod' ? 'Beta' : 'Prod';
  const [header, setHeader] = useState(EmbeddingURLErrorMessages.URL_CONFIGURE_UNKNOWN);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (error === EmbeddingURLErrorMessages.URL_NOT_CONFIGURED) {
      setHeader('Ooops! Missing Embed URL');
      setMessage(`You've turned on embedding for this app, but we couldn't find URL to load it. Provide ${envName} link to fix it.`);
    } else if (error === EmbeddingURLErrorMessages.URL_INVALID) {
      // The row does have an applicationLink / non-prod link, but the
      // client-side sanitizer rejected it (non-https, javascript:, data:, or
      // malformed). This is the stored-XSS defense refusing to hand a
      // dangerous URL to an iframe src. Tell the admin the link is invalid
      // rather than "missing" so they know to update — not add — the URL.
      setHeader('Invalid URL');
      setMessage(`The configured ${envName} URL is invalid and cannot be displayed. Update the application link to a valid https:// URL.`);
    } else if (error === EmbeddingURLErrorMessages.URL_CONFIGURE_UNKNOWN) {
      setMessage('There was an issue with the application configuration. Please contact support.');
    }
  }, [error]);

  return (
    <div className={styles.centeredStateContainer}>
      <div className={styles.centeredStateContentWrapper}>
        <Alert action={<FinsuiteIssueActionButton />} type={'error'} header={header}>
          {message}
        </Alert>
      </div>
    </div>
  );
};
